import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ListaItem } from '../../_models/lista-item';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { ReglasNegocioVinculacionService } from '../../_services/reglas-negocio-vinculacion.service';
import { ReglasNegocioVinculacion } from '../../_models/reglas-negocio-vinculacion';
import { ReglasNegocioVinculacionConfiguracion } from '../../_models/reglas-negocio-vinculacion-configuracion';
import { ReglasNegocioVinculacionConfiguracionService } from '../../_services/reglas-negocio-vinculacion-configuracion.service';
import { ReglasNegocioPlazo } from '../../_models/reglas-negocio-plazo';
import { ReglasNegocioPlazoService } from '../../_services/reglas-negocio-plazo.service';

@Component({
  selector: 'app-reglas-negocio',
  templateUrl: './reglas-negocio.component.html',
  styleUrls: ['./reglas-negocio.component.css']
})
export class ReglasNegocioComponent implements OnInit {

  loading: boolean = true;
  formularioVinculacion: FormGroup;
  formularioPlazo: FormGroup;
  tabSeleccionado: string = 'PLAZO';
  listVinculacion: SelectItem[] = [];
  listVinculacionTemp: ListaItem[] = [];
  listPlazo: SelectItem[] = [];
  listPlazoTemp: ListaItem[] = [];
  submitted: boolean = false;
  columnas: any[] = [];
  columnasPlazo: any[] = [];
  loadingTablaVincu: boolean = false;
  vinculaciones: ReglasNegocioVinculacion[] = [];
  vinculacionesTemp: ReglasNegocioVinculacion[] = [];
  plazos: ReglasNegocioPlazo[] = [];
  plazosTemp: ReglasNegocioPlazo[] = [];
  listUnidadCredito: ReglasNegocioVinculacionConfiguracion[] = [];
  mostrarCantidad: boolean = false;
  saveVinculacion: boolean = false;
  saveUnidadCredito: boolean = false;
  savePlazo: boolean = false;
  escluir: string[] = ['DEUDOR', 'NOFIR'];
  editVinculacion: boolean = false;
  editPlazo: boolean = false;
  mostrarModalUnidCredito: boolean = false;
  loadingTablaPlazo: boolean = true;

  constructor(
    private navServicio: NavService,
    private  fb: FormBuilder,
    private lisServicio: ListaService,
    private confirmacionServicio: ConfirmationService,
    private reglasNegocioVinculacionServicio: ReglasNegocioVinculacionService,
    private reglasNegocioVinculacionConfiguracionService: ReglasNegocioVinculacionConfiguracionService,
    private reglasNegocioPlazoService: ReglasNegocioPlazoService
  ) { }

  ngOnInit(): void {
    this.columnas = [
      { field: 'vinculacion', header: this.navServicio.buscarMensaje( 'RENEGOCIO.LBL_VINCULACION' ), sort: false },
      { field: 'cantidad', header: this.navServicio.buscarMensaje( 'RENEGOCIO.LBL_CANTIDAD' ), sort: false },
      { field: 'misvinculacion', header: this.navServicio.buscarMensaje( 'RENEGOCIO.LBL_MISVINCULA' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.columnasPlazo = [
      { field: 'idTipoPlazo', header: this.navServicio.buscarMensaje( 'RENEGOCIO.LBL_TIPOPLAZO' ), sort: false },
      { field: 'desde', header: this.navServicio.buscarMensaje( 'RENEGOCIO.LBL_DESDESIN' ), sort: false },
      { field: 'hasta', header: this.navServicio.buscarMensaje( 'RENEGOCIO.LBL_HASTASIN' ), sort: false },
      { field: 'cantidadCredito', header: this.navServicio.buscarMensaje( 'RENEGOCIO.LBL_CANTCREDITO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    forkJoin(
      this.lisServicio.getMasterDetails( 'ListasTiposVinculaciones' ),
      this.reglasNegocioVinculacionServicio.getAll(),
      this.lisServicio.getMasterDetails( 'ListasPlazosCreditos' ),
      this.reglasNegocioPlazoService.getAll()
    )
    .subscribe( ([res, reglas, listPlazos, plazos]) => {
       this.listVinculacionTemp = res;
       this.listPlazoTemp = listPlazos;
       res.map( r => {
          if (!this.escluir.includes(r.codigo)) {
            this.listVinculacion.push({label: r.nombre, value: r.idLista});
          }
       });
        listPlazos.map( l => {
          this.listPlazo.push({label: l.nombre, value: l.idLista});

        })
      if (reglas.length > 0) {
        this.vinculaciones = reglas.filter( r => r.indicadorHabilitado);
        this.vinculacionesTemp = reglas;
        const idListaTipVin = res.map( r => r.idLista);
        this.vinculaciones.map( p => {
          if (idListaTipVin.includes(p.idVinculacion)) {
            this.toggleListVinculacion(p.idVinculacion, true);
          }
        });
      }

      if (plazos.length > 0) {
        this.plazos = plazos.filter( p => p.indicadorHabilitado);
        this.plazosTemp = plazos;
        const idListaTipVin = res.map( r => r.idLista);
        this.plazos.map( p => {
          if (idListaTipVin.includes(p.idTipoPlazo)) {
              this.toggleListPlazo(p.idTipoPlazo, true);
          }
        });
      }
       this.loading = false;
      this.loadingTablaPlazo = false;
    });
    this.initFormularioVinculacion();
    this.initFormularioPlazo();
  }

  initFormularioVinculacion() {
    this.formularioVinculacion = this.fb.group({
        idReglaNegocioVinculacion: [ null , []],
        idVinculacion: [ null, [Validators.required]],
        cantidad: [ null, []],
        indicadorVinculacion: [false, []],
        tipoVinculacion: [null, []],
        indicadorHabilitado: [true, []]

    });
  }

  get fv () {
    return this.formularioVinculacion.controls;
  }

  initFormularioPlazo() {
    this.formularioPlazo = this.fb.group({
      idReglaNegocioPlazo: [ null , []],
      idTipoPlazo: [ null, [Validators.required]],
      desde: [ null, [Validators.required, Validators.min(1)]],
      hasta: [null, [Validators.required, Validators.min(1)]],
      cantidadCredito: [null, [Validators.required, Validators.min(1)]],
      nombre: [null, []],
      indicadorHabilitado: [true, []]
    });
  }

  get fp () {
    return this.formularioPlazo.controls;
  }

  abrirAcordeon(evento: number) {
    switch ( evento ) {
      case 0: {
        this.tabSeleccionado = 'PLAZO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'VINCULACION';
        break;
      }
      default: {
        break;
      }
    }
  }

  onSubmitVinculacion() {
    this.submitted = true;
    if (this.formularioVinculacion.valid) {
      this.saveVinculacion = true;
      this.loadingTablaVincu = true;
      this.loading = true;
      const data = this.formularioVinculacion.getRawValue();
      data.nombre = this.listVinculacionTemp.find( l => l.idLista === data.idVinculacion).nombre;
      const equals = this.vinculacionesTemp.find( v => v.idVinculacion === data.idVinculacion);
      if (this.editVinculacion || equals) {
        equals.indicadorHabilitado = true;
        equals.cantidad = data.cantidad;
        equals.indicadorVinculacion = data.indicadorVinculacion ? true : false;
        this.reglasNegocioVinculacionServicio.update(equals).subscribe( resp => {
          resp.tipoVinculacion = data.nombre;
          const position = this.vinculacionesTemp.findIndex( v => v.idReglaNegocioVinculacion === resp.idReglaNegocioVinculacion);
          if ( position >= 0 ) {
            this.reloadTable();
          }
          this.toggleListVinculacion(data.idVinculacion, true);
          this.fv.cantidad.setValidators(null);
          this.formularioVinculacion.reset();
          this.submitted = false;
          this.saveVinculacion = false;
          this.loadingTablaVincu = false;
          this.editVinculacion = false;
          this.mostrarCantidad = false;
          this.navServicio.setMesage( 2 );
        });
      } else {
        this.reglasNegocioVinculacionServicio.add(data).subscribe( resp => {
          resp.tipoVinculacion = data.nombre;
          this.reloadTable();
          this.toggleListVinculacion(data.idVinculacion, true);
          this.fv.cantidad.setValidators(null);
          this.formularioVinculacion.reset();
          this.submitted = false;
          this.saveVinculacion = false;
          this.loadingTablaVincu = false;
          this.mostrarCantidad = false;
          this.navServicio.setMesage( 1 );
        });
      }
    }
  }

  toggleCantidad(event: any) {
    this.mostrarCantidad = event;
    if (event) {
      this.fv.cantidad.setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.fv.cantidad.setValue(null);
      this.fv.cantidad.setValidators(null);
      this.fv.cantidad.setErrors(null);
    }
  }

  eliminarVinculacion(data: ReglasNegocioVinculacion) {
    this.confirmacionServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'RENEGOCIO.MSG_ELIM' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'eliminarVinculacion',
      accept: () => {
        data.indicadorHabilitado = false;
        this.loading = true;
        this.reglasNegocioVinculacionServicio.update(data).subscribe( resp => {
          this.vinculaciones.splice(this.vinculaciones.findIndex( v => v.idReglaNegocioVinculacion === resp.idReglaNegocioVinculacion), 1);
          this.toggleListVinculacion(data.idVinculacion, false);
          if (this.editVinculacion) {
            this.toggleListVinculacion(data.idVinculacion, true);
          }
          this.formularioVinculacion.reset();
          this.submitted = false;
          this.saveVinculacion = false;
          this.loadingTablaVincu = false;
          this.editVinculacion = false;
          this.mostrarCantidad = false;
          this.reloadTable();
          this.navServicio.setMesage( 2 );
        });
      }
    } );
  }

  editarVinculacion(data: ReglasNegocioVinculacion) {
    this.toggleListVinculacion(data.idVinculacion, false);
    this.fv.idReglaNegocioVinculacion.setValue(data.idReglaNegocioVinculacion);
    this.fv.idVinculacion.setValue(data.idVinculacion);
    this.fv.cantidad.setValue(data.cantidad);
    this.fv.indicadorVinculacion.setValue(data.indicadorVinculacion);
    this.toggleCantidad(data.indicadorVinculacion);
    this.editVinculacion = true;
  }

  toggleModalUnidadCredito(bandera: boolean, data?: ReglasNegocioVinculacion) {
    this.formularioVinculacion.reset();
    this.listUnidadCredito = [];
    this.mostrarModalUnidCredito = !this.mostrarModalUnidCredito;
    if (data) {
      this.fv.idReglaNegocioVinculacion.setValue(data.idReglaNegocioVinculacion);
    }
    if (bandera) {
      this.reglasNegocioVinculacionConfiguracionService.getByIdReglasNegocioVinculacion(data.idReglaNegocioVinculacion).subscribe( resp => {
        this.listUnidadCredito = resp.filter( r => r.indicadorHabilitado);
      });
    }
  }

  toggleListVinculacion(id: string, bandera: boolean) {
    if (bandera) {
      this.listVinculacion.splice( this.listVinculacion.findIndex( l => l.value === id), 1);
    } else {
      const obj = this.listVinculacionTemp.find( l => l.idLista === id);
      this.listVinculacion.push({label: obj.nombre, value: obj.idLista});
    }
  }

  addUnidCredito() {
    this.listUnidadCredito.push({
      id:null,
      idReglaNegocioVinculacionConfiguracion: null,
      idReglaNegocioVinculacion: this.fv.idReglaNegocioVinculacion.value,
      unidadCredito: 1,
      indicadorHabilitado: true,
      auditoriaUsuario: null,
      auditoriaFecha: null
    });
  }

  deleteUnidCredito(posision: number) {
    const valid  = this.listUnidadCredito[posision];
    if (valid && valid.idReglaNegocioVinculacionConfiguracion) {
      valid.indicadorHabilitado = false;
      this.reglasNegocioVinculacionConfiguracionService.update(valid).subscribe( resp => {
        this.listUnidadCredito.splice(posision, 1);
      });
    } else {
      this.listUnidadCredito.splice(posision, 1);
    }
  }

  onSubmitUnidadCredito() {
    const validate = this.listUnidadCredito.filter( l => !l.unidadCredito);
    if (validate.length > 0) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'RENEGOCIO.MSG_VALNULL' )
      } );
      return;
    } else if (this.listUnidadCredito.length === 0) {
      this.navServicio.setMesage( 0, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'RENEGOCIO.MSG_REQUERIDO' )
      } );
      return;
    }
    this.saveUnidadCredito = true;
    this.reglasNegocioVinculacionConfiguracionService.bulk(this.listUnidadCredito).subscribe( resp => {
      this.navServicio.setMesage( 1 );
      this.saveUnidadCredito = false;
      this.toggleModalUnidadCredito(false);
    });
  }

  onSubmitPlazo() {
    this.submitted = true;
    if (this.formularioPlazo.valid) {
      this.savePlazo = true;
      this.loadingTablaPlazo = true;
      this.loading = true;
      const data = this.formularioPlazo.getRawValue();
      data.nombre = this.listPlazoTemp.find( l => l.idLista === data.idTipoPlazo).nombre;
      const equals = this.plazosTemp.find( v => v.idReglaNegocioPlazo === data.idReglaNegocioPlazo);
      if (this.editPlazo || equals) {
        equals.desde = data.desde;
        equals.hasta = data.hasta;
        equals.cantidadCredito = data.cantidadCredito;
        this.reglasNegocioPlazoService.update(equals).subscribe( resp => {
          resp.nombre = data.nombre;
          const position = this.plazosTemp.findIndex( v => v.idReglaNegocioPlazo === resp.idReglaNegocioPlazo)
          if (position >= 0) {
            this.reloadTable();
          }
          this.toggleListPlazo(data.idTipoPlazo, true);
          this.formularioPlazo.reset();
          this.submitted = false;
          this.savePlazo = false;
          this.loadingTablaPlazo = false;
          this.editPlazo = false;
          this.navServicio.setMesage( 2 );
        });
      } else {
        this.reglasNegocioPlazoService.add(data).subscribe( resp => {
          resp.nombre = data.nombre;
          this.reloadTable();
          this.toggleListPlazo(data.idTipoPlazo, true);
          this.formularioPlazo.reset();
          this.submitted = false;
          this.savePlazo = false;
          this.loadingTablaPlazo = false;
          this.navServicio.setMesage( 1 );
        });
      }
    }
  }

  eliminarPlazo(row: ReglasNegocioPlazo) {
    this.confirmacionServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'RENEGOCIO.MSG_ELIM' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'eliminarVinculacion',
      accept: () => {
        row.indicadorHabilitado = false;
        this.loading = true;
        this.reglasNegocioPlazoService.update(row).subscribe( resp => {
          this.plazos.splice(this.plazos.findIndex( v => v.idReglaNegocioPlazo === resp.idReglaNegocioPlazo), 1);
          this.toggleListPlazo(row.idTipoPlazo, false);
          if (this.editPlazo) {
            this.toggleListPlazo(row.idTipoPlazo, true);
          }
          this.formularioPlazo.reset();
          this.submitted = false;
          this.savePlazo = false;
          this.loadingTablaPlazo = false;
          this.editPlazo = false;
          this.reloadTable();
          this.navServicio.setMesage( 2 );
        });
      }
    } );
  }

  editarPlazo(row: ReglasNegocioPlazo) {
    this.toggleListPlazo(row.idTipoPlazo, false);
    this.fp.idReglaNegocioPlazo.setValue(row.idReglaNegocioPlazo);
    this.fp.idTipoPlazo.setValue(row.idTipoPlazo);
    this.fp.desde.setValue(row.desde);
    this.fp.hasta.setValue(row.hasta);
    this.fp.cantidadCredito.setValue(row.cantidadCredito);
    this.fp.indicadorHabilitado.setValue(true);
    this.editPlazo = true;
  }

  toggleListPlazo(id: string, bandera: boolean) {
    if (bandera) {
      this.listPlazo.splice( this.listPlazo.findIndex( l => l.value === id), 1);
    } else {
      const obj = this.listPlazoTemp.find( l => l.idLista === id);
      this.listPlazo.push({label: obj.nombre, value: obj.idLista});
    }
  }

  reloadTable() {
    forkJoin(
      this.reglasNegocioVinculacionServicio.getAll(),
      this.reglasNegocioPlazoService.getAll()
    ).subscribe( ([resp, resp2]) => {
      if (resp.length > 0) {
        this.vinculaciones = resp.filter( r => r.indicadorHabilitado);
        this.vinculacionesTemp = resp;
      }

      if (resp2.length > 0) {
        this.plazos = resp2.filter( r => r.indicadorHabilitado);
        this.plazosTemp = resp2;
      }

      this.loading = false;

    });
  }

}
